/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_sini } from "../../App/actions/sini_v2";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class SINI_AI extends Component {
  state = {};

  on_activate_sini_ai = () => {
    this.props.set_value_sini({
      key: "sini_menu_active",
      value: "post_ai_chat",
    });
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    //global props

    //content

    return (
      <main className="container_light background_white margin_bottom outline_grey">
        <div
          className="badge background_grey_light margin_bottom"
          onClick={this.on_set_sini_menu_active}
        >
          SINI AI
        </div>
        <br />

        <div className="sini_container_animation">
          <div className="sini_shape_animation sini_circle_1"></div>
          <div className="sini_shape_animation sini_circle_2"></div>
          <div className="sini_shape_animation sini_circle_3"></div>
        </div>

        <br />
        <button
          className="button_big background_black"
          onClick={this.on_activate_sini_ai}
          data-mapid="clickChat"
        >
          {dict?.["Start SINI AI"]?.[language]}
        </button>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { set_value_sini })(SINI_AI);
